import React from "react";
import { isMobile } from "react-device-detect";

import GlobalSearchResultsMobile from "./GlobalSearchResultsMobile";
import GlobalSearchResultsDesktop from "./GlobalSearchResultsDesktop";

function GlobalSearchResults(props) {
  return isMobile ? <GlobalSearchResultsMobile {...props} /> : <GlobalSearchResultsDesktop {...props} />;
}

export default GlobalSearchResults;
